export default {"src":"/_next/static/media/Rancher.ce9cba46.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};